import { i18n } from "@bundles/UIAppBundle/i18n";
import phrases from "./config/Users.i18n.json";
import errorPhrases from "./config/Users.errors.i18n.json";
i18n.push(phrases);
i18n.push(errorPhrases);
// You can override additional messages here by using i18n.push();
